import React from 'react'
import { get } from 'lodash'
import { Redirect } from 'react-router-dom'
import config from 'config'
import OrganizationContactRegistration
  from '../../containers/pages/OrganizationContactRegistration/OrganizationContactRegistration'

const urlPrefix = `${config.publicPath}/oc-registration`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <OrganizationContactRegistration logout {...props} />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={{
            pathname: `${config.publicPath}/oc-registration`,
            search: get(props, 'location.search')
          }}
          />
        ),
        routes: []
      }
    ]
  }
]
